import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-box game-edit" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Link", -1)
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Release", -1)
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "field field-select" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "store" }, "Type", -1)
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "buttons" }
const _hoisted_17 = ["textContent"]

import { computed, onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Actions, Mutations } from '@/store';
import { WishlistItem, WishlistItemType } from '@/models/wishlist.model';
import Choice, { Item } from '@/components/choice/Choice.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistEdit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const item = reactive<WishlistItem>(new WishlistItem());
const isEdit = ref<boolean>(false);
const types = ref<Item[]>([
  {
    value: WishlistItemType.Game,
    label: 'Game',
  },
  {
    value: WishlistItemType.Hardware,
    label: 'Hardware',
  },
]);

const action = computed<string>(() => {
  return isEdit.value ? 'Edit' : 'Add';
});
const title = computed<string>(() => {
  return action.value + ' wishlist item';
});

onMounted(async () => {
  if (~route.path.indexOf('edit') && !store.state.item) {
    // on reload
    isEdit.value = true;
    store.dispatch(Actions.GetWishlistByName, route.params.title).then((i) => {
      Object.assign(item, i);
    });
  } else if (store.state.item) {
    // on edit from another page
    isEdit.value = true;
    Object.assign(item, store.state.item);
  } else {
    // get all items
    store.dispatch(Actions.GetWishlist);
    Object.assign(item, new WishlistItem());
  }
});

const cancel = () => {
  store.commit(Mutations.SetViewItem, null);
  router.push('/wishlist');
};

const submit = async () => {
  if (item.isValid()) {
    const response = await store.dispatch(Actions.UpdateWishlistItem, {
      item,
      edit: isEdit.value,
    });
    if (response.status) {
      cancel();
    }
  }
};

const remove = async () => {
  const response = await store.dispatch(Actions.RemoveWishlistItem, item);
  if (response.status) {
    cancel();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", {
      textContent: _toDisplayString(_unref(title))
    }, null, 8, _hoisted_2),
    item
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.name) = $event))
            }, null, 512), [
              [_vModelText, item.name]
            ]),
            (!item.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(item.validation.messages['name'])
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "link",
              name: "link",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.link) = $event))
            }, null, 512), [
              [_vModelText, item.link]
            ]),
            (!item.isValid('link'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(item.validation.messages['link'])
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "release",
              name: "release",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.release) = $event))
            }, null, 512), [
              [_vModelText, item.release]
            ]),
            (!item.isValid('release'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(item.validation.messages['release'])
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(Choice, {
              modelValue: item.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.type) = $event)),
              id: "type",
              items: types.value
            }, null, 8, ["modelValue", "items"]),
            (!item.isValid('store'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(item.validation.messages['type'])
                }, null, 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "cancel",
              onClick: cancel
            }, "Cancel"),
            _createElementVNode("button", {
              type: "button",
              class: "danger",
              onClick: remove
            }, "Remove"),
            _createElementVNode("button", {
              type: "submit",
              textContent: _toDisplayString(_unref(action))
            }, null, 8, _hoisted_17)
          ])
        ], 40, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})